import {
    DTOCardFormField,
} from 'app/types/form.types'
import {
    LocationType,
} from 'app/enums/label.enums'

import {
    CreateContainerFields,
} from '../../containers.types'

const fields: DTOCardFormField<CreateContainerFields>[] = [
    {
        title: 'CREATE_CONTAINER',
        className: 'createContainer',
        id: 'createContainer',
        fields: [
            {
                id: 'column1',
                fields: [{
                    name: 'containerType',
                    componentName: 'SelectContainerTypeByCode',
                    labelKey: 'CONTAINER_TYPE',
                    required: true,
                }],
            },
            {
                id: 'column2',
                fields: [{
                    name: 'serialNumberSuffixFrom',
                    labelKey: 'SERIAL_NUMBER_COUNTER_FROM',
                    componentName: 'IntegerInput',
                    required: true,
                }],
            },
            {
                id: 'column3',
                fields: [{
                    name: 'numberOfContainers',
                    componentName: 'IntegerInput',
                    required: true,
                    labelKey: 'AMOUNT_OF_CONTAINERS',
                }],
            },
        ],
    },
    {
        title: 'ADDITIONAL_INFORMATION',
        className: 'additionalInformation',
        id: 'additionalInformation',
        fields: [
            {
                name: 'location',
                componentName: 'LocationObjectSelector',
                filterLocationType: LocationType.ADDRESS,
                labelKey: 'LOCATION',
                required: true,
            },
            {
                name: 'financingContract',
                componentName: 'InputSingleline',
                labelKey: 'FINANCING_CONTRACT',
            },
            {
                name: 'containerModel',
                componentName: 'IntegerInput',
                labelKey: 'CONTAINER_MODEL',
                required: true,
            },
        ],
    },
]

export default fields
